<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="FG Allocations">
          <template slot="actions">
              <vs-button id="export-formulation-button" @click.stop="onClickDownloadSheet" color="warning" type="border">
                Export
              </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              id="customer-site-list-table"
              :max-items="meta.per_page ? meta.per_page : 10"
              :data="formulationList"
              :sst="true"
              stripe
              class="table-dark-inverted table-auto vs-con-loading__container"
            >
              <template slot="thead">
                <vs-th sort-key="formulation_code">FG CODE</vs-th>
                <vs-th>FG NAME</vs-th>
                <vs-th>% OF FG</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                  style="cursor: pointer"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                >
                  <vs-td :data="data[indextr].formulation_code">
                    <HyperLink :id="data[indextr].id" type="formulation">{{ data[indextr].formulation_code }}</HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].quantity_percentage">
                    {{ data[indextr].quantity_percentage }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              v-can="'view-site'"
              :total="meta.last_page ? meta.last_page : 0"
              v-model="page"
              class="p-5"
            ></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";

const SupplierRawMaterialRepository = RepositoryFactory.get(
  "supplierRawMaterial"
);

export default {
  name: "supplierRawMaterialFgAllocation",
  data() {
    return {
      id: null,
      formulationList: [],
      page: 1,
      total: 0,
      meta: {},
      sort: "",
    };
  },
  props: {
    rm_code: {
      type: String,
      default: ''
    }
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.getAttachedFormulations();
  },
  methods: {
    async refreshData() {
      this.getAttachedFormulations();
    },
    async getAttachedFormulations() {
      try {
        const response =
          await SupplierRawMaterialRepository.getFormulationsAttachedToRawMaterial(
            this.id,
            this.page,
            null
          );
        this.formulationList = response.data.data;
        this.meta = response.data.meta;
      } catch (e) {}
    },
    handleChangePage(page) {
      this.page = page;
      this.getAttachedFormulations();
    },
    async onClickDownloadSheet(){
        await this.$vs.loading({
          container: '#export-formulation-button',
          scale: 0.45
        })
        try {
          const response = await SupplierRawMaterialRepository.downloadRawMaterialData(this.id)
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${this.rm_code}_FG_Allocation_Sheet.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        } catch (e) {

        }
        this.$vs.loading.close('#export-formulation-button > .con-vs-loading')
      } 
  },
  watch: {
    page() {
      this.getAttachedFormulations();
    },
  },
};
</script>
